export const MIN_MESSAGE_LENGTH: number = 1;
export const LINE_BREAK: string = "\n";
export const ENTER_KEY: string = "Enter";
export const { webkitSpeechRecognition } = (window as any)